var App = App || {};

App.SiteModals = (function ($) {
    'use strict';

    const modalSpeedbump = $("#ModalSpeedbump");
    const modalCustomList = [];
    $(".site-modals-custom > .modal").each(function () {
        modalCustomList.push($(this).attr("id"));
    });

    // initialize specific functions
    // NOTE: ModalsTriggerClick is it's own function because it needs to be accessed by links in our react apps
    // NOTE: triggering a modal via #id-of-modal is in App.Base.HashSupport alongside support for accordions and tabs
    function init() {
        ModalsTriggerClick($("a"));
    }

    // trigger any modals on click
    function ModalsTriggerClick(selector) {

        selector.on("click", function (e) {

            const url = $(this).attr("href");
            const speedbumpExemptList = SpeedbumpData.ExemptList;

            // indicates a speedbump
            if (this.hostname !== location.hostname
                && $.inArray(this.hostname, speedbumpExemptList) === -1
                && url
                && url.indexOf("#") !== 0
                && !isUriSchema(url)) {

                e.preventDefault();
                SpeedbumpModal(url);
            }

            // indicates a custom modal
            else if (url.indexOf("#") === 0 && modalCustomList.includes(url.replace("#", ""))) {
                e.preventDefault();
                const modal = $("#" + url.replace("#", ""));
                modal.modal("show");
            }

        });
    }

    // speedbump modal functionality
    function SpeedbumpModal(url) {
        modalSpeedbump.modal("show");
        modalSpeedbump.find("button[data-bs-proceed='modal']")
            .off("click")
            .on("click", function () {
                modalSpeedbump.modal("hide");
                window.open(url);
            }
            );
    }

    // helper functions
    function isUriSchema(url) {

        const uriSchemes = ['javascript:', 'mailto:', 'tel:'];

        for (var i in uriSchemes) {
            if (url.indexOf(uriSchemes[i]) > -1) {
                return true;
            }
        }
        return false;
    }

    return {
        init: init,
        ModalsTriggerClick: ModalsTriggerClick
    };

})(jQuery);

$(function () {
    App.SiteModals.init();
});